import React from 'react';
import styled from 'styled-components';

export const Heading1 = styled.h1`
  font-family: 'Poppins-Light';
  font-size: 1.0rem;
`;

export const Heading2 = styled.h2`
  font-family: 'Poppins-Medium';
  font-size: 2.25rem;
  line-height: 2.75rem;
`;

export const Heading3 = styled.h3`
  font-family: 'Poppins-Medium';
  font-size: 1.75rem;
  line-height: 2.25rem;
`;

export const Heading4 = styled.h4`
  font-family: 'Poppins-Medium';
  font-size: 1.4rem;
  line-height: 2rem;
`;


export const Paragraph = styled.p`
  font-family: 'Poppins-Regular';
  font-size: 1.1rem;
  line-height: 1.6rem;
  color: #333;
`;

export const Caption = styled.span`
  font-family: 'Poppins-Light';
  font-size: 0.9rem;
  line-height: 1.2rem;
  color: #888;
`;

export const Label = styled.label`
  font-family: 'Poppins-Regular';
  font-size: 1rem;
  color: #555;
`;

export const ButtonText = styled.button`
  font-family: 'Poppins-SemiBold';
  font-size: 1.1rem;
  padding: 10px 16px;
  border: none;
  background: #333;
  color: white;
  cursor: pointer;
  border-radius: 4px;

  &:hover {
    background: #000;
  }
`;

export const LinkText = styled.a`
  font-family: 'Poppins-Regular';
  font-size: 1rem;
  color: #007BFF;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const NavLink = styled.a`
  font-family: 'Poppins-Regular';
  font-size: 0.8rem;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
  color: black;
`;

export const ProductName = styled.p`
  font-family: 'Poppins-Bold';
  margin: 0 auto;
  font-size: 0.8rem;
  margin: 0.5rem 0rem;
`;

export const ProductUnitType = styled.p`
  font-family: 'Poppins-Light';
  margin: 0 0;
  font-size: 0.8rem;
  text-align: left;
`;

export const ProductUnitAmount = styled.p`
  font-family: 'Poppins-Light';
  margin: 0 0;
  font-size: 0.8rem;
  text-align: right;
  font-weight: 600;
  padding-right: 0.2rem;
`;

export const CartItemName = styled.p`
  font-family: 'Poppins-Bold';
  margin: 0 0;
  font-size: 0.8rem;
`;

export const OrderSummaryAmount = styled.p `
  font-family: 'Poppins-SemiBold';
  margin: 0 0;
  font-size: 1rem;
  text-align: right;
  padding-right: 0.2rem;
`;

export const OrderSummaryProductName = styled.p`
  font-family: 'Poppins-Medium';
  margin: 0 0;
  font-size: 0.8rem;
`;

export const OrderSummaryProducTotalAmount = styled.p `
  font-family: 'Poppins-Medium';
  margin: 0 auto;
  font-size: 0.9rem;
  text-align: right;
  padding-right: 0.2rem;
`;

